const PaginationConfig = {
  itemsPerPage: 144
};

export default PaginationConfig;
